import React from "react";
import classes from "./Box.module.css";

export default function Box({ className, children }) {
  return (
    <div className={[classes.container, className && className].join(" ")}>
      {children}
    </div>
  );
}
